module.exports = __webpack_public_path__ + "static/media/gts15.aed81b2a.png";